"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KNOWN_CARD_ATTRIBUTE_KEYS = void 0;
exports.cardAttributeLabel = cardAttributeLabel;
exports.cardAttributeLabels = cardAttributeLabels;
const i18n_1 = require("./i18n");
/** Keys the checklist knows how to name. Anything else is shown as written. */
exports.KNOWN_CARD_ATTRIBUTE_KEYS = ['cost', 'attack', 'health', 'type'];
const KNOWN_KEYS = new Set(exports.KNOWN_CARD_ATTRIBUTE_KEYS);
function cardAttributeLabel(locale, key) {
    const i18nKey = `card.attr.${key}`;
    const text = (0, i18n_1.t)(locale, i18nKey);
    return text === i18nKey ? key : text;
}
/**
 * Known keys always come first, in dictionary order. Extra keys follow,
 * sorted by code unit, and use the raw key when neither locale has a label.
 */
function cardAttributeLabels(keys) {
    const extra = [];
    const seen = new Set();
    for (const key of keys) {
        if (seen.has(key) || KNOWN_KEYS.has(key))
            continue;
        seen.add(key);
        extra.push(key);
    }
    extra.sort((left, right) => (left < right ? -1 : left > right ? 1 : 0));
    const labels = {};
    for (const key of [...exports.KNOWN_CARD_ATTRIBUTE_KEYS, ...extra]) {
        labels[key] = {
            'zh-CN': cardAttributeLabel('zh-CN', key),
            'en-US': cardAttributeLabel('en-US', key),
        };
    }
    return labels;
}
//# sourceMappingURL=card-attribute-label.js.map